import React from 'react';
import { Contact, Footer } from '../components'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Meta from '../components/common/Meta';
import image from '../assets/images/services/services-header.jpg';


export const ContactPage = () => {
  return (
    <div>
      <Meta
        title="Contact Us | Architecture & Engineering Consultants Rwanda"
        description="Contact Edges Design Group for architectural design, engineering consulting, construction management, surveying, and project advisory services in Rwanda."
        keywords="
          Construction consultant Rwanda,
          Building project advisor Kigali,
          Construction technical support,
          Quantity surveying Rwanda,
          Construction cost management Kigali,
          Project budgeting and estimation,
          Land surveying Rwanda,
          Site analysis Kigali,
          Topographic survey services,
          Building project advisor Kigali
          "
      />

      <header
        className="relative min-h-[320px] flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative text-center px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white uppercase tracking-wide">
            Contact Us
          </h1>
          <p className="mt-4 text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            Let's talk about your next project. We're here to help you build something great.
          </p>
        </div>
      </header>

      <ToastContainer />
      <Contact />
      <div className=' w-full h-1 bg-gray-400'></div>
      <Footer />
    </div>
  )
}

export default ContactPage
